import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import vuedraggable from 'vuedraggable';
export default {
  name: 'layer',
  inject: ["contain"],
  provide: function provide() {
    return {
      contain: this.contain
    };
  },
  components: {
    draggable: vuedraggable
  },
  props: {
    count: {
      type: Number,
      default: 1
    },
    nav: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    handleGetActive: function handleGetActive(item) {
      return this.contain.active.includes(item.index);
    },
    handleSetActive: function handleSetActive(item) {
      if (this.contain.keys.ctrl) {
        if (!Array.isArray(this.contain.active)) {
          this.contain.handleInitActive();
        }

        this.contain.active.push(item.index);
      } else {
        this.contain.active = [item.index];
      }
    },
    hangeChangeName: function hangeChangeName(item) {
      this.$set(item, 'isname', !item.isname);
    },
    openFolder: function openFolder(item) {
      this.$set(item, 'menu', !item.menu);
      item.isname = false;
    }
  }
};